import { api, TOKEN_KEY } from "@/lib/api";

export async function uploadDocument(file, { vehicle_id, title, category = "invoice", expiry_date }) {
  const fd = new FormData();
  fd.append("file", file); fd.append("title", title || file.name); fd.append("category", category);
  if (vehicle_id) fd.append("vehicle_id", vehicle_id);
  if (expiry_date) fd.append("expiry_date", expiry_date);
  const { data } = await api.post("/documents", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}

export async function uploadVehiclePhoto(file, { vehicle_id, note, issue_id }) {
  const fd = new FormData();
  fd.append("file", file); fd.append("vehicle_id", vehicle_id); fd.append("panel", "other"); fd.append("kind", "general");
  if (note) fd.append("note", note);
  if (issue_id) fd.append("issue_id", issue_id);
  const { data } = await api.post("/photos", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}

export const docUrl = (id) => `${process.env.REACT_APP_BACKEND_URL}/api/documents/${id}/download?auth=${localStorage.getItem(TOKEN_KEY)}`;

export function FileField({ label = "Attach photo / PDF", accept = "image/*,application/pdf", inputRef, testId, hint }) {
  return (
    <label className="block space-y-1.5 sm:col-span-2">
      <span className="text-sm font-medium">{label}</span>
      <input ref={inputRef} type="file" accept={accept} capture={accept.startsWith("image/*") && !accept.includes("pdf") ? "environment" : undefined} data-testid={testId} className="fv-input py-2 text-xs" />
      {hint && <span className="text-xs text-muted-foreground">{hint}</span>}
    </label>
  );
}
